@if (uploadProgressService.getUpdateProgressByFileName(delayedFileUploadItem().fileName)) {
  <app-file-progress-bar-status/>
} @else {
  <div class="selected-files-item">
    <span class="selected-files-name">
      {{ delayedFileUploadItem().fileName }}
    </span>
    <button
      mat-icon-button
      class="action-btn"
      matTooltip="Удалить выбранный файлы"
      (click)="handleDeleteFile()"
    >
      <mat-icon>delete</mat-icon>
    </button>
  </div>
}
